import { useMemo } from 'react';
/* @bend-expect import-missing-runtime-dep */
import styled from 'styled-components';

/* @bend-expect import-missing-runtime-dep */
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { HTMLSanitizerConfig } from '../utils/HTMLSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
// Some browsers may handle the `annotation` tag inconsistently if a parent `semantics` tag is missing.
// https://developer.mozilla.org/en-US/docs/Web/MathML/Element/annotation#:~:text=Annotations%20are%20not%20supposed%20to%20be%20rendered%20by%20browsers%20and%20are%20hidden%20by%20default
const AlwaysHideAnnotations = styled.div.withConfig({
  displayName: "SafeHTML__AlwaysHideAnnotations"
})(["annotation{display:none;}"]);
export const SafeHTML = ({
  html
}) => {
  const sanitizedHtml = useMemo(() => {
    return sanitize(html, HTMLSanitizerConfig);
  }, [html]);
  return /*#__PURE__*/_jsx(AlwaysHideAnnotations, {
    children: /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: sanitizedHtml
      }
    })
  });
};